import { Navigate } from "react-router-dom";
import { ReactNode, useEffect } from "react";
import useNotificationStore from "../../setup/store/useNotificationStore";
import { useAuth } from "../../context/AuthContext";
import LoadingPage from "../modules/loading/LoadingPage";

interface ProtectedRouteProps {
  children: ReactNode;
}
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { session, loading } = useAuth();
  const { showNotif } = useNotificationStore();

  // Fire the "must be logged in" notice as a post-render effect, NOT during
  // render. Calling showNotif() inline set Zustand state during render, which
  // triggered a re-render, which called showNotif() again — React killed the
  // loop after 50 cycles ("Maximum update depth exceeded").
  // See SENTRY-COPPER-ELEPHANT-Q.
  useEffect(() => {
    if (!loading && !session) {
      showNotif("Must be logged in to access page", false);
    }
  }, [loading, session, showNotif]);

  if (loading) return <LoadingPage />;
  if (!session) return <Navigate to="/" />;

  return children;
};

export default ProtectedRoute;
